<template>
    <v-container>
        <!-- Navigation row -->
        <v-row justify="center" v-if="!isContractor">
            <v-btn-toggle rounded mandatory v-model="selectionIdx">
                <v-btn>{{ $t('key.overview') }}</v-btn>
                <v-btn>{{ $t('key.details') }}</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- Filter row -->
        <v-row v-if="isSuperAdmin">
            <v-col>
                <v-select :items="provinces" item-text="text" item-value="value"
                          v-model="selectedProvinces" @change="onProvinceSelectionChange"
                          dense chips multiple></v-select>
            </v-col>
        </v-row>

        <v-row v-if="selectionIdx === 0">
            <ReportOverview />
        </v-row>

        <v-row v-if="selectionIdx === 1">
            <ReportDetails />
        </v-row>
    </v-container>
</template>

<script>
    import ReportOverview from '@/components/detail/report/Overview';
    import ReportDetails from '@/components/detail/report/Details';
    import {Provinces, Roles} from '@/components/_helpers';

    export default {
        name: 'Report',
        components: {
            ReportOverview,
            ReportDetails
        },
        data: () => ({
            selectionIdx: 0, // Default selection: Overview
            selectedProvinces: []
        }),
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated
            },
            isSuperAdmin() {
                let userProfile = this.$store.getters.userProfile
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_1.value
            },
            isContractor() {
                let userProfile = this.$store.getters.userProfile
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_3.value
            },
            provinces() {
                return Provinces.list()
            }
        },
        mounted() {
            this.$store.dispatch('getUsers')

            // get user profile
            let userProfile = this.$store.getters.userProfile

            // initialize UI component
            this.selectedProvinces = (userProfile.role === Roles.ROLE_1.value)
                ? Provinces.list().map(p => p.value)
                : [userProfile.province]

            // set filter arguments
            let filterArgs = (userProfile.role === Roles.ROLE_1.value)
                ? {} // no filtering needed for SUPERADMIN
                : {usersRef: this.filterUsersByProvinces([userProfile.province])}

            // query data with given arguments
            this.$store.dispatch('filterSurveys', filterArgs)
        },
        methods: {
            filterUsersByProvinces(provinces) {
                // get users
                let users = this.$store.getters.userList

                // filter users which belongs to the same province
                return users.filter(user => provinces.includes(user.province))
            },
            onProvinceSelectionChange(selectedProvinces) {
                console.log(selectedProvinces)

                let filterArgs = {usersRef: this.filterUsersByProvinces(selectedProvinces)}

                // query data with given arguments
                this.$store.dispatch('filterSurveys', filterArgs)
            }
        }
    }
</script>

<style />
